/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { O5AwsDeployerV1StackEvent } from '@interxfi/types';
import { schema } from 'normalizr';

export const O5_AWS_DEPLOYER_V1_STACK_EVENT_ENTITY_NAME = 'o5.aws.deployer.v1.StackEvent';
export const o5AwsDeployerV1StackEventEntity = new schema.Entity<O5AwsDeployerV1StackEvent>(O5_AWS_DEPLOYER_V1_STACK_EVENT_ENTITY_NAME, {}, { idAttribute: (entity: O5AwsDeployerV1StackEvent) => `${entity.metadata?.eventId}` });

